// 会议相关 Matrix 事件类型常量
export const MATRIX_EVENT_TYPE_MEETING = 'org.matrix.msc3401.call'; 